import { render } from "./KeyboardComponent.vue?vue&type=template&id=23e85734&scoped=true&ts=true"
import script from "./KeyboardComponent.vue?vue&type=script&lang=ts"
export * from "./KeyboardComponent.vue?vue&type=script&lang=ts"

import "./KeyboardComponent.vue?vue&type=style&index=0&id=23e85734&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e85734"]])

export default __exports__